const envVal = (() => {
  if (['dev', '192', 'localhost', '10.0', '172'].some(h => location.hostname.indexOf(h) > -1)) {
    return {
      prefix: 'dev',
      val: 2,
    };
  }

  if (location.hostname.indexOf('test') > -1) {
    return {
      prefix: 'test',
      val: 1,
    };
  }

  return {
    prefix: '',
    val: 0,
  };
})();

export const env = envVal.val;

export const envPrefix = envVal.prefix;

export const isLocalhost = ['192', 'localhost', '10.0'].some(h => location.hostname.indexOf(h) > -1);

export const apiBase = `https://${envPrefix}api.666visa.cn/www/peer`;

export const mapiBase = `https://${envPrefix}mapi.666visa.cn`;

export const ossBase = `https://${envPrefix}o.666visa.cn/`;



// WEBPACK FOOTER //
// ./src/libs/env.js